import axios from "axios";
import { UverifyClientConfig } from "./client-config";
import { useQuery } from "@tanstack/react-query";

const fetchClientConfigTranslation = async (language: string) => {
  const { data } = await axios.get(
    `https://uverifystorage.blob.core.windows.net/static/translation/${language}.json`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return data;
};

export const useClientConfigTranslation = (language: string) => {
  return useQuery<UverifyClientConfig>(
    ["client-config-translation", language],
    () => fetchClientConfigTranslation(language)
  );
};